module.exports = __webpack_public_path__ + "static/virtualOffice-bac73e2a9231e5f2a1e5850b57916946.jpg";